export default Object.freeze({
  GET_EXPO_STANDARDS: "GET_EXPO_STANDARDS"
});
